import { IDonorProfileHeaderInfo } from '@nkr/models/index';

export const initialHeaderData: IDonorProfileHeaderInfo = {
    id: 0,
    alias: '',
    isTransplanted: true,
    isExportable: false,
    isActive: false,
    isAdp: false,
    creatinineClearance: 0,
    positionInSwap: 0,
    clusterId: 0,
    clusterNumber: 0,
    clusterStatusId: 0,
    clusterStatus: '',
    chainId: 0,
    chainStatusId: 0,
    chainStatus: '',
    lastOrderDate: '',
    validationResults: [],
    dataCompliance: [],
    canOrderCheekSwab: false,
    hasAdpFile: false,
    recipientId: 0,
    recipientAlias: '',
    recipientCenterId: 0,
    recipientType: null,
    // adpRecipientId: 0,
    canConvert: false,
    canDelete: false,
    alleleData: false,
    donorCenterId: 0,
    donationCenterId: 0,
    statusId: 0,
    wageAndTravelRequest: false,
    registrationId: 0,
    requisitionId: 0,
    isRequisition: false,
    isExpertSystemParticipant: false,
    isInExpertSystem: false
}